/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : clientInfoUtil.ts
// 설명 : 로그인 이력(ZA_LOGIN_HIST)에 남길 접속 환경 중 "브라우저만 알 수 있는 값"(화면 크기/배율, 시간대,
//        화면 언어, 플랫폼)을 모아서 로그인/2차인증/로그아웃 요청에 함께 보냄. IP/User-Agent 등은 서버가 요청 헤더에서 직접 추출함.
/////////////////////////////////////////////////////////////////////////////////////////////////////////
export interface ClientInfo {
  screen?: string;
  timeZone?: string;
  uiLang?: string;
  platform?: string;
}

export function getClientInfo(uiLang?: string): ClientInfo {
  try {
    const nav: any = navigator;
    return {
      screen: `${window.screen?.width ?? 0}x${window.screen?.height ?? 0}@${window.devicePixelRatio ?? 1}`,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      uiLang: uiLang || nav.language,
      platform: nav.userAgentData?.platform || nav.platform || undefined,
    };
  } catch {
    return {};
  }
}
